import { memo, useCallback } from "react";

interface YesNoDialogProps {
  title: string;
  message: string;
  show: boolean;
  onClose: (result: boolean) => void;
}

const BACKDROP_STYLE = {
  backgroundColor: "rgba(0,0,0,0.5)",
} as const;

function YesNoDialog({ title, message, show, onClose }: YesNoDialogProps) {
  const handleNo = useCallback(() => onClose(false), [onClose]);
  const handleYes = useCallback(() => onClose(true), [onClose]);

  if (!show) {
    return null;
  }

  return (
    <div
      className="modal show d-block"
      style={BACKDROP_STYLE}
      role="dialog"
      aria-modal="true"
      aria-labelledby="yesno-dialog-title"
      aria-describedby="yesno-dialog-message"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 id="yesno-dialog-title" className="modal-title">
              {title}
            </h5>
          </div>
          <div id="yesno-dialog-message" className="modal-body">
            <p>{message}</p>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-custom-small-white"
              onClick={handleNo}
            >
              No
            </button>
            <button
              type="button"
              className="btn btn-custom-small"
              onClick={handleYes}
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

YesNoDialog.displayName = "YesNoDialog";

export default memo(YesNoDialog);
